export default {"src":"/_next/static/media/vi.0168bf1b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};